module.exports = __webpack_public_path__ + "img/11_kristin-wilson.a9b0aed1.jpg";